module.exports = __webpack_public_path__ + "img/building.f9ea87f3.svg";